import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { Auth, Hub } from 'aws-amplify'
import { useState, useEffect, useCallback } from 'react'

import { Icon } from '@src/quince-components/src'
import LoaderWrapper from '@src/quince-components/src/atoms/loaderWrapper/LoaderWrapper'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import GoogleSvg from './google_log.inline.svg'
import styles from './googleSignIn.module.scss'
import { getSanitizedRedirectUrls } from '../utils'

interface GoogleSignInPropTypes {
  onLoginCompletion: (user: any, cb: () => void) => void
}

const GoogleSignIn = (props: GoogleSignInPropTypes) => {
  const { onLoginCompletion } = props
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const eventListener = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsLoading(false)
      }
    }

    window.addEventListener('pageshow', eventListener)
    return () => {
      window.removeEventListener('pageshow', eventListener)
    }
  }, [])

  const getUser = useCallback(async (): Promise<void> => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser()
      onLoginCompletion(currentUser, () => {
        setIsLoading(false)
      })
    } catch (error) {
      console.error(error)
    }
  }, [onLoginCompletion])

  const onGoogleSignInButtonClick = useCallback(() => {
    const redirectUri = getSanitizedRedirectUrls()
    setIsLoading(true)
    if (redirectUri) {
      sessionStorage.setItem('redirecturi', JSON.stringify(redirectUri))
    }
    Auth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider.Google,
    }).catch((e: unknown) => {
      console.error('Erron while calling federatedSignIn, onGoogleSignInButtonClick() runtime:: ', e)
    })
  }, [])

  useEffect(() => {
    if (!isBrowser()) {
      return
    }
    const unsubscribe = Hub.listen('auth', ({ payload: { event } }) => {
      switch (event) {
        case 'signIn':
          setIsLoading(true)
          break
      }
    })
    getUser().catch((e: unknown) => {
      console.error('Erron while calling getUser:: ', e)
    })
    return unsubscribe
  }, [getUser])

  return (
    <div
      onClick={onGoogleSignInButtonClick}
      className={isLoading ? styles.googleSignInButton__loading : styles.googleSignInButton}
    >
      {isLoading ? (
        <LoaderWrapper
          loadWrapperClassName={styles.pageLoader}
          showLoader
          containerClassName={styles.containerPageLoader}
        />
      ) : (
        <>
          <Icon iconSvg={GoogleSvg} className={styles.icon} />
          <div className={styles.loginText}>CONTINUE WITH GOOGLE</div>
        </>
      )}
    </div>
  )
}
export { GoogleSignIn }
